/**
 * Soft-fade content images once they decode, avoiding the hard shunt-in.
 * Skips decorative icons that opt out with data-no-fade / .no-fade.
 */
(() => {
  const SELECTOR = 'img:not([data-no-fade]):not(.no-fade)';

  function markLoaded(img) {
    img.classList.add('is-loaded');
  }

  function enhance(img) {
    if (!(img instanceof HTMLImageElement)) return;
    if (img.classList.contains('img-reveal')) return;

    img.classList.add('img-reveal');

    // Keep LCP heroes visible; fade everything that still needs to decode
    if (
      img.getAttribute('fetchpriority') === 'high' ||
      (img.complete && img.naturalWidth > 0)
    ) {
      markLoaded(img);
      return;
    }

    img.addEventListener('load', () => markLoaded(img), { once: true });
    img.addEventListener('error', () => markLoaded(img), { once: true });
  }

  function enhanceAll(scope = document) {
    scope.querySelectorAll(SELECTOR).forEach(enhance);
  }

  document.documentElement.classList.add('js');

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => enhanceAll(), { once: true });
  } else {
    enhanceAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    enhanceAll(event.target);
  });

  if ('MutationObserver' in window) {
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof HTMLElement)) return;
          if (node.matches?.(SELECTOR)) enhance(node);
          else enhanceAll(node);
        });
      }
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
